"use client";

// Segment-felgräns. Fångar render-fel i sidträdet, loggar dem och visar en
// tema-vänlig fallback med "Försök igen" (reset).

import { useEffect } from "react";
import { reportError } from "@/lib/error-report";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportError({
      kalla: "error-boundary",
      meddelande: error.message,
      stack: error.stack,
      digest: error.digest,
    });
  }, [error]);

  return (
    <div
      style={{
        padding: "3rem 1.5rem",
        maxWidth: "32rem",
        margin: "0 auto",
        textAlign: "center",
      }}
    >
      <h1 style={{ fontSize: "1.5rem", marginBottom: "0.75rem" }}>
        Något gick fel
      </h1>
      <p style={{ color: "var(--color-text-muted)", marginBottom: "1.5rem" }}>
        Vi har loggat felet automatiskt. Försök igen — funkar det inte, ladda om
        sidan.
      </p>
      <button
        type="button"
        onClick={() => reset()}
        title="Försök rendera sidan igen"
        style={{
          padding: "0.6rem 1.4rem",
          borderRadius: "0.5rem",
          border: "1px solid var(--color-accent)",
          color: "var(--color-accent)",
          background: "transparent",
          cursor: "pointer",
        }}
      >
        Försök igen
      </button>
    </div>
  );
}
